import { render, staticRenderFns } from "./ContactsListToAssign.vue?vue&type=template&id=2c38363e&scoped=true"
import script from "./ContactsListToAssign.vue?vue&type=script&lang=js"
export * from "./ContactsListToAssign.vue?vue&type=script&lang=js"
import style0 from "./ContactsListToAssign.vue?vue&type=style&index=0&id=2c38363e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38363e",
  null
  
)

export default component.exports